import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import API from 'shared/constants/api';
import Link from 'shared/components/Link';
import { bindActionCreators } from 'redux';
import { setSavedSearches } from 'shared/actions/user';
import { withTranslate } from 'shared/hocs/withTranslate';
import { enqueueNotification } from 'shared/actions/notifications';
import { getSaveSearchParams } from 'shared/helpers/searchSubscriptions';
import VerifyEmailModal from 'shared/components/VerifyEmailModal/VerifyEmailModal';
import {
  SUB_OPTIONS,
  ERROR_MESSAGE,
  TO_MATCH_SUB_MESSAGE,
} from 'shared/constants/searchSubscriptions';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { camelCaseToUpperCase } from 'shared/modules';
import { withFetch } from 'shared/hocs/withFetch';
import s from './SavedSearchItem.css';

class SavedSearchItem extends React.Component {
  static propTypes = {
    user: PropTypes.shape(),
    savedSearches: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    setSearches: PropTypes.func.isRequired,
    enqueueNotif: PropTypes.func.isRequired,
    updateStateItemPeriod: PropTypes.func,
    togglePopup: PropTypes.func,
    searchItem: PropTypes.shape().isRequired,
    //
    fetch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    user: {},
    updateStateItemPeriod: () => {},
    togglePopup: () => {},
  };

  state = {
    location: null,
    stateNotifPeriod: SUB_OPTIONS[4],
    showVerifyModal: false,
  };

  updatedStoreSearches = updatedSearch => {
    const { savedSearches, setSearches } = this.props;

    const newSavedSearches = savedSearches.map(item => {
      if (item.id === updatedSearch.id) return updatedSearch;
      return item;
    });

    setSearches(newSavedSearches);
  };

  deleteSearchSub = () => {
    const {
      user: { token },
      enqueueNotif,
      setSearches,
      savedSearches,
      togglePopup,
      searchItem,
      t,
    } = this.props;

    fetch(API.ADVERT.SEARCH_SUB_BY_ID(searchItem.id), {
      method: 'DELETE',
      headers: {
        Authorization: `JWT ${token}`,
      },
    }).then(resp => {
      if (resp.ok) {
        // start deleting item from array
        const deletedItem = savedSearches.find(item => item.id === searchItem.id);
        const index = savedSearches.indexOf(deletedItem);

        if (index > -1) savedSearches.splice(index, 1);
        setSearches([]);
        setSearches(savedSearches);
        togglePopup();
        enqueueNotif(t('Подписка на поиск удалена'));
        // end deleting item from array
      } else {
        enqueueNotif(t(ERROR_MESSAGE));
        togglePopup();
      }
    });
  };

  updatePeriod = period => {
    const {
      fetch,
      updateStateItemPeriod,
      user: { token },
      enqueueNotif,
      searchItem,
      setSearches,
      savedSearches,
      t,
    } = this.props;

    const updatedSearch = { ...searchItem, update_period: period.key };
    updateStateItemPeriod(updatedSearch);
    this.updatedStoreSearches(updatedSearch);

    fetch(API.ADVERT.SEARCH_SUB_BY_ID(searchItem.id), {
      method: 'PATCH',
      body: JSON.stringify({ update_period: period.key }),
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
    }).then(resp => {
      if (resp.status === 402) {
        setSearches(savedSearches);
        enqueueNotif(t(TO_MATCH_SUB_MESSAGE));
      } else if (resp.status === 400) {
        updateStateItemPeriod(searchItem);
        setSearches(savedSearches);

        this.setState({ showVerifyModal: true });
      } else if (resp.status !== 200) enqueueNotif(t(ERROR_MESSAGE));
    });
  };

  switchVerifyModal = (e = false) => {
    if (e) e.preventDefault();
    this.setState({ showVerifyModal: !this.state.showVerifyModal });
  };

  render() {
    const { searchItem, t } = this.props;
    const { stateNotifPeriod, showVerifyModal } = this.state;

    const notifPeriod = searchItem
      ? SUB_OPTIONS.find(item => item.key === searchItem.update_period)
      : stateNotifPeriod;

    const infoSearchParams = searchItem ? getSaveSearchParams(searchItem, t) : [];
    const plusCountParams = infoSearchParams.length - 3;

    return (
      <div className={s.root}>
        <div className={s.titleBlock}>
          <Link to={camelCaseToUpperCase(searchItem.link)} className={s.savedTitle}>
            {searchItem.title}
          </Link>
          <i className={`fa fa-trash ${s.trashIcon}`} onClick={this.deleteSearchSub} />
        </div>
        <div className={s.infoBlock}>
          {infoSearchParams.slice(0, 3).map(item =>
            <div className={s.infoItem} key={item.title}>
              <div className={s.infoTitle}>
                {item.title}:
              </div>
              <div>
                {`${item.value} ${item.unitMeasurement || ''}`}
              </div>
            </div>,
          )}
          {plusCountParams > 0
            ? <div className={s.infoItem}>
                <div className={s.infoTitle}>
                  {`+ ${plusCountParams} параметр`}
                </div>
              </div>
            : ''}
        </div>
        <div>
          <Select
            onChange={this.updatePeriod}
            labelKey={'label'}
            valueKey={'key'}
            value={notifPeriod}
            options={SUB_OPTIONS}
            clearable={false}
            searchable={false}
          />
        </div>
        <VerifyEmailModal switchModal={this.switchVerifyModal} showModal={showVerifyModal} />
      </div>
    );
  }
}

const mapStateToProps = ({ user, globals }) => ({
  location: globals.location,
  savedSearches: user.savedSearches || [],
  user,
});

const mapDispatchToProps = dispatch => ({
  enqueueNotif: bindActionCreators(enqueueNotification, dispatch),
  setSearches: bindActionCreators(setSavedSearches, dispatch),
});

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(withFetch(withTranslate(SavedSearchItem))),
);



// WEBPACK FOOTER //
// ./src/shared/components/SavedSearchItem/SavedSearchItem.js